import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('payment_details'),
    warningText: defineMessage('this_bill_was_published_ould_be_created_as_well'),
    dateField: defineMessage('date'),
    accountField: defineMessage('account'),
    amountField: defineMessage('amount'),
};
